import React from "react";
import { GridLoader } from "react-spinners";

function Loader() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <GridLoader color="#231651" />
    </div>
  );
}

export default Loader;
